import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const AccessDenied = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [loading, setLoading] = useState(true); // État pour afficher ou non le contenu
  const [isAuthenticated, setIsAuthenticated] = useState(false); // État de l'authentification

  useEffect(() => {
    // Vérifie l'authentification de l'utilisateur au premier rendu
    const authToken = localStorage.getItem('access_token'); // Remplacez par votre logique d'authentification
    const redirectUrl = localStorage.getItem('redirectAfterLogin');
    console.log(location.pathname)

    if (authToken) {
      setIsAuthenticated(true); // L'utilisateur est authentifié

      // Vérifie si l'utilisateur est redirigé vers l'URL de redirection
      if (location.pathname === '/simulateur') {
        // localStorage.removeItem('redirectAfterLogin');
        console.log('url : ', location.pathname)
        window.location.reload();
      }
    } else {
      setIsAuthenticated(false); // L'utilisateur n'est pas authentifié
    }
  }, [location.pathname]); // Dépend de `location.pathname` pour vérifier à chaque changement d'URL

  useEffect(() => {
    // Vérifie si l'utilisateur est authentifié pour rediriger
    if (isAuthenticated) {
      const redirectUrl = localStorage.getItem('redirectAfterLogin');
      if (redirectUrl) {
        navigate(redirectUrl); // Rediriger vers la page d'origine
      }
      setLoading(false); // Ne bloque pas le rendu si authentifié
    } else if (!isAuthenticated && location.pathname !== '/') {
      // Si l'utilisateur n'est pas authentifié, on stocke l'URL actuelle et on redirige
      localStorage.setItem('redirectAfterLogin', location.pathname);

      // Rediriger après 1 seconde vers la page de connexion
      const timer = setTimeout(() => {
        navigate('/'); // Rediriger vers la page de connexion
      }, 1000);

      // Nettoyage du timer si le composant est démonté avant la redirection
      return () => clearTimeout(timer);
    } else {
      setLoading(false); // Fin des vérifications, afficher la page si pas de redirection
    }
  }, [isAuthenticated, navigate, location.pathname]);

  // Ne pas afficher le contenu tant que les vérifications ne sont pas faites
  if (loading) return null; // Retourner null (rien à afficher) tant que la vérification est en cours

  return (
    <div style={styles.container}>
      <h1 style={styles.title}>Accès refusé</h1>
      <p style={styles.message}>
        Vous n'avez pas les accès nécessaires pour accéder à cette page.
      </p>
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh', // Pour centrer verticalement
    backgroundColor: '#f5f5f5', // Arrière-plan doux
    color: '#333', // Couleur du texte
  },
  title: {
    fontSize: '3rem',
    marginBottom: '1rem',
    color: '#ff4757', // Couleur de titre rouge
  },
  message: {
    fontSize: '1.5rem',
    color: '#555', // Couleur de message légèrement gris
  },
};

export default AccessDenied;
